var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWarningIcon = function SvgWarningIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7775 15.2891L11.4454 1.07031C10.8075 -0.0234375 9.19777 -0.0234375 8.55558 1.07031L0.227455 15.2891C-0.413561 16.3789 0.384838 17.75 1.66964 17.75H18.3337C19.6134 17.75 20.4142 16.3828 19.7775 15.2891ZM9.06261 5.5625C9.06261 5.04492 9.48254 4.625 10.0001 4.625C10.5177 4.625 10.9376 5.04688 10.9376 5.5625V10.5625C10.9376 11.0801 10.5177 11.5 10.0353 11.5C9.55285 11.5 9.06261 11.082 9.06261 10.5625V5.5625ZM10.0001 15.25C9.32199 15.25 8.77199 14.7 8.77199 14.0219C8.77199 13.3438 9.3216 12.7937 10.0001 12.7937C10.6786 12.7937 11.2282 13.3438 11.2282 14.0219C11.2267 14.6992 10.6798 15.25 10.0001 15.25Z",
    fill: "#CE9400"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarningIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning-icon.c1c14204.svg";
export { ForwardRef as ReactComponent };